import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import "react-phone-input-2/lib/style.css";
// import { FaTrash } from "react-icons/fa";
// import { MdEditSquare } from "react-icons/md";
import "react-datepicker/dist/react-datepicker.css";
import ConfirmationModal from "../../components/common/confirm/ConfirmationModal";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { MdSearch } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { deleteLead, fetchLeads } from "../../store/slices/leadsSlice";
import { clearsetFilteredNavData } from "../../store/slices/LeadreportfilteredSlice";
import { setCurrentPageTitle, resetcurrentLeadID } from "../../store/slices/pageSlice";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useCurrencySymbol } from "../../utils/currencyUtils";
import DateConversion from "../../utils/DateConversion";
import CommaConvert from "../../utils/CommaConvert";
import { SquarePen, Trash2, EllipsisVertical } from "lucide-react";

const LeadReport11 = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const currency = useCurrencySymbol();
  const { formatDateByCountry } = DateConversion();
  const USAComma = CommaConvert();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Lead Report"));
    dispatch(resetcurrentLeadID());
  }, [dispatch]);

  const filteredNavData = useSelector(
    (state) => state.leadreportfiltered.filteredNavData
  );
  const groupsFromSlice = useSelector((state) => state.group?.group || []);

  const groupNameById = useMemo(() => {
    const map = new Map();
    const normalize = (value) => String(value ?? "").trim();
    const groups = Array.isArray(groupsFromSlice) ? groupsFromSlice : [];
    groups.forEach((groupItem) => {
      const groupId = normalize(groupItem?._id ?? groupItem?.id);
      if (!groupId) return;
      const groupName = normalize(
        groupItem?.name ??
        groupItem?.newGroupName ??
        groupItem?.groupName ??
        groupItem?.GroupName ??
        groupId
      );
      map.set(groupId, groupName || groupId);
    });
    return map;
  }, [groupsFromSlice]);

  const [originalLeadReportsL1_11, setOriginalLeadReportsL1_11] = useState([]);
  const [filteredLeadReports, setFilteredLeadReports] = useState([]);
  const getLeadGroupName = (lead) => {
    const normalize = (value) => String(value ?? "").trim();
    const groupIdFromObject = normalize(lead?.groupid?._id ?? lead?.groupid?.id);
    if (groupIdFromObject && groupNameById.has(groupIdFromObject)) {
      return groupNameById.get(groupIdFromObject);
    }
    const groupIdFromString = typeof lead?.groupid === "string" ? normalize(lead.groupid) : "";
    if (groupIdFromString && groupNameById.has(groupIdFromString)) {
      return groupNameById.get(groupIdFromString);
    }
    return (
      lead?.groupid?.newGroupName ||
      lead?.groupid?.groupName ||
      lead?.groupid?.GroupName ||
      lead?.groupid?.name ||
      (groupIdFromString ? groupIdFromString : "") ||
      lead?.AssignedGroup ||
      ""
    );
  };
  console.log("originalLeadReportsL1_11", originalLeadReportsL1_11)

  useEffect(() => {
    if (
      originalLeadReportsL1_11.length === 0 &&
      filteredLeadReports.length > 0
    ) {
      setOriginalLeadReportsL1_11(filteredLeadReports); // Store only once when data loads
    }
  }, [filteredLeadReports, originalLeadReportsL1_11]);

  useEffect(() => {
    if (Array.isArray(filteredNavData) && filteredNavData.length > 0) {
      setFilteredLeadReports(filteredNavData);
    } else {
      setFilteredLeadReports([]); // Clear state if no data is available
    }

    return () => {
      clearsetFilteredNavData();
    };
  }, [filteredNavData]);

  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const location = useLocation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [LeadToDelete, setLeadToDelete] = useState(null);

  const dropdownsRef = useRef(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If dropdown is open and click is outside the dropdown AND not on the dropdown icon
      if (openDropdownId && dropdownsRef.current && !dropdownsRef.current.contains(event.target)) {
        // Also check if the click was on the ellipsis icon itself
        const clickedElement = event.target;
        const isEllipsisIcon = clickedElement.closest('.dropdown-toggle-icon');

        if (!isEllipsisIcon) {
          setOpenDropdownId(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdownId]);

  const openDeleteModal = (id) => {
    setLeadToDelete(id);
    setIsModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setLeadToDelete(null);
  };

  const confirmDelete = async () => {
    if (LeadToDelete) {
      await deleteLeadReport(LeadToDelete); // Call your existing delete function
    }
    closeDeleteModal();
  };

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    filterLeadReports(query);
    setCurrentPage(1);
  };

  const filterLeadReports = (query) => {
    const trimQuery = query.toLowerCase().trim(); // Normalize query
    const lowerCaseQuery = trimQuery.replace(/,/g, '').toLowerCase();

    if (!query.trim()) {
      setFilteredLeadReports(originalLeadReportsL1_11); // Restore original data
      return;
    }

    const filtered = originalLeadReportsL1_11.filter((LeadReport) =>
      Object.entries(LeadReport).some(([key, value]) => {
        if (
          key === "comments" ||
          key === "Reference" ||
          key === "ClientContactName" ||
          key === "TypeService" ||
          key === "Probability" ||
          key === "ClientPhone" ||
          key === "ClientEmail" ||
          key === "LeadOwner" ||
          key === "AssignedPeople" ||
          key === "AssignedPeopleEmail" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "LeadOwnerEmail"
          || key === "quotedExpense" || key === "_id" || key === "id" || key === "__v"
        )
          return false;
        if (value !== null && value !== undefined) {
          if (key === "AssignedGroup" || key === "groupid") {
            return getLeadGroupName(LeadReport).toLowerCase().includes(lowerCaseQuery);
          }
          let formattedValue = value.toString().trim().toLowerCase();

          // If value is a Date object
          if (value instanceof Date) {
            formattedValue = formatDateByCountry(value).trim().toLowerCase();
          }
          // If value is a string that might be a date (ISO format)
          else if (typeof value === "string") {
            const dateValue = new Date(value);
            if (!isNaN(dateValue)) {
              formattedValue = formatDateByCountry(dateValue).trim().toLowerCase();
            }
          }

          return formattedValue.includes(lowerCaseQuery);
        }

        return false;
      })
    );

    setFilteredLeadReports(filtered);
  };


  const deleteLeadReport = async (id) => {
    try {
      await dispatch(deleteLead(id)).unwrap(); // ✅ Call Redux action instead of axios
      enqueueSnackbar("Leadreport deleted successfully!", {
        variant: "success",
      });
      dispatch(fetchLeads());
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar("Failed to delete Leadreport!", { variant: "error" });
    }
  };

  const [itemsPerPage] = useState(10);
  const totalItems = filteredLeadReports.length;
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const totalPages = Math.ceil(filteredLeadReports.length / itemsPerPage);
  const currentData = filteredLeadReports.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const [, setRefreshTable] = useState(false);

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;
    const sortedReports = [...filteredLeadReports].map((item) => ({ ...item }));

    switch (key) {
      case "business-az":
        sortedReports.sort((a, b) =>
          getLeadGroupName(a).localeCompare(getLeadGroupName(b))
        );
        setRefreshTable((prev) => !prev);
        break;

      case "business-za":
        sortedReports.sort((a, b) =>
          getLeadGroupName(b).localeCompare(getLeadGroupName(a))
        );
        setRefreshTable((prev) => !prev);
        break;

      case "client-az":
        sortedReports.sort((a, b) =>
          a.ClientName.localeCompare(b.ClientName)
        );
        setRefreshTable((prev) => !prev);
        break;

      case "client-za":
        sortedReports.sort((a, b) =>
          b.ClientName.localeCompare(a.ClientName)
        );
        setRefreshTable((prev) => !prev);
        break;

      case "project-az":
        sortedReports.sort((a, b) =>
          a.ProjectName.localeCompare(b.ProjectName)
        );
        setRefreshTable((prev) => !prev);
        break;

      case "project-za":
        sortedReports.sort((a, b) =>
          b.ProjectName.localeCompare(a.ProjectName)
        );
        setRefreshTable((prev) => !prev);
        break;

      case "leadtype-az":
        sortedReports.sort((a, b) =>
          a.LeadType.localeCompare(b.LeadType)
        );
        setRefreshTable((prev) => !prev);
        break;

      case "leadtype-za":
        sortedReports.sort((a, b) =>
          b.LeadType.localeCompare(a.LeadType)
        );
        setRefreshTable((prev) => !prev);
        break;

      case "leadstatus-az":
        sortedReports.sort((a, b) => a.Status.localeCompare(b.Status));
        setRefreshTable((prev) => !prev);
        break;

      case "leadstatus-za":
        sortedReports.sort((a, b) => b.Status.localeCompare(a.Status));
        setRefreshTable((prev) => !prev);
        break;

      case "leadate-az": // Oldest to Latest
        sortedReports.sort(
          (a, b) => new Date(a.LeadDate) - new Date(b.LeadDate)
        );
        setRefreshTable((prev) => !prev);
        break;

      case "leadate-za": // Latest to Oldest
        sortedReports.sort(
          (a, b) => new Date(b.LeadDate) - new Date(a.LeadDate)
        );
        setRefreshTable((prev) => !prev);
        break;

      case "followupdate-az": // Oldest to Latest, N/A at end
        sortedReports.sort((a, b) => {
          if (!a.FollowupDate) return 1; // Move N/A to the end
          if (!b.FollowupDate) return -1;
          return new Date(a.FollowupDate) - new Date(b.FollowupDate);
        });
        setRefreshTable((prev) => !prev);
        break;

      case "source-az":
        sortedReports.sort((a, b) => a.Source.localeCompare(b.Source));
        setRefreshTable((prev) => !prev);
        break;

      case "source-za":
        sortedReports.sort((a, b) => b.Source.localeCompare(a.Source));
        setRefreshTable((prev) => !prev);
        break;

      case "followupdate-za": // Latest to Oldest, N/A at end
        sortedReports.sort((a, b) => {
          if (!a.FollowupDate) return 1; // Move N/A to the end
          if (!b.FollowupDate) return -1;
          return new Date(b.FollowupDate) - new Date(a.FollowupDate);
        });
        setRefreshTable((prev) => !prev);
        break;

      default:
        console.error("Invalid Order");
    }
    setFilteredLeadReports(sortedReports)
  };

  const numericSort = (order) => {
    order === "az"
      ? filteredLeadReports.sort(
        (a, b) => Number(a.QuotedValue) - Number(b.QuotedValue)
      )
      : filteredLeadReports.sort(
        (a, b) => Number(b.QuotedValue) - Number(a.QuotedValue)
      );

    setRefreshTable((prev) => !prev);
  };

  return (
    <>
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={closeDeleteModal}
        onConfirm={confirmDelete}
      />
      <div className="">
        <div
          className="pt-2 pb-2 relative overflow-y-scroll justify-center rounded-md"
        >
          <div className="flex-col p-2 bg-white rounded-t">
            <div className="flex justify-between items-center">
              <div>
                <h1 className="text-2xl w-full  mb-2 font-semibold">
                  Lead Report
                </h1>
              </div>

              <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                <MdSearch className=" w-5 h-5 text-gray-500" />
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  placeholder="Search"
                  className="bg-[#e0e7ff] outline-none w-[80%]"
                />
              </div>
            </div>
          </div>
          <div className="max-h-[580px] overflow-auto border bg-white">
            <table className="min-w-[1400px] divide-y divide-gray-200 ">
              <thead className="bg-[#e8e8e8] sticky top-0 z-50">
                <tr className="font-semibold">
                  <th className="px-2 py-1 text-start border text-xs tracking-wider">
                    Sr. No
                  </th>
                  <th className="px-2 w-24 py-1 text-start border text-xs capitalize tracking-wider">
                    <div className="flex items-center justify-center gap-x-4">
                      Lead Date
                      <div className="flex flex-col gap-y-1">
                        <div
                          className="cursor-pointer "
                          onClick={() => sortAlphabetically("leadate", "az")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => sortAlphabetically("leadate", "za")}
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                  <th className="px-2 py-1 text-start border text-xs capitalize tracking-wider">
                    <div className="flex items-center justify-between gap-x-4">
                      Client Name
                      <div className="flex flex-col gap-y-1">
                        <div
                          className="cursor-pointer "
                          onClick={() => sortAlphabetically("client", "az")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => sortAlphabetically("client", "za")}
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                  <th className="px-2 py-1 text-start border text-xs  capitalize tracking-wider">
                    <div className="flex items-center justify-between gap-x-4">
                      Project Name
                      <div className="flex flex-col gap-y-1">
                        <div
                          className="cursor-pointer"
                          onClick={() => sortAlphabetically("project", "az")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => sortAlphabetically("project", "za")}
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                  <th className="px-2 py-1 text-start border text-xs capitalize tracking-wider">
                    <div className="flex items-center justify-center gap-x-4">
                      Lead Type
                      <div className="flex flex-col gap-y-1">
                        <div
                          className="cursor-pointer "
                          onClick={() => sortAlphabetically("leadtype", "az")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => sortAlphabetically("leadtype", "za")}
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                  <th className="px-2 py-1 text-start border text-xs capitalize tracking-wider">
                    <div className="flex items-center justify-between">
                      Quoted Value ({currency})
                      <div className="flex flex-col gap-y-1">
                        <div
                          className="cursor-pointer"
                          onClick={() => numericSort("za")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => numericSort("az")}
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                  <th className="px-2 py-1 text-start border text-xs capitalize tracking-wider">
                    <div className="flex items-center justify-between">
                      Status
                      <div className="flex flex-col gap-y-1">
                        <div
                          className="cursor-pointer "
                          onClick={() => sortAlphabetically("leadstatus", "az")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => sortAlphabetically("leadstatus", "za")}
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                  <th className="px-2 py-1 text-start border text-xs capitalize tracking-wider">
                    <div className="flex justify-between items-center">
                      Source
                      <div className="flex flex-col gap-y-1">
                        <div
                          className="cursor-pointer"
                          onClick={() => sortAlphabetically("source", "az")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => sortAlphabetically("source", "za")}
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                  <th className="px-2 py-1 text-start border text-xs capitalize tracking-wider">
                    <div className="flex items-center justify-between">
                      Group
                      <div className="flex flex-col gap-y-1">
                        <div
                          className="cursor-pointer"
                          onClick={() => sortAlphabetically("business", "az")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => sortAlphabetically("business", "za")}
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                  <th className="px-2 py-1 text-start border text-xs capitalize tracking-wider">
                    <div className="flex items-center justify-between">
                      Follow-up Date
                      <div className="flex flex-col gap-y-1">
                        <div
                          className="cursor-pointer"
                          onClick={() => sortAlphabetically("followupdate", "az")}
                        >
                          <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => sortAlphabetically("followupdate", "za")}
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                  <th className="px-2 py-1 text-center border text-xs text-capitalize tracking-wider text-capitalize">
                    Action
                  </th>
                </tr>
              </thead>

              {/* {groupFilter === "All" || groupFilter === "" ? ( */}
              <tbody className="bg-white">
                {currentData.length > 0 ? (
                  currentData?.map((LeadReport, index) => (
                    <tr className=" text-xs border-gray-400 min-h-10" key={LeadReport.id}>
                      <td className="px-2 py-1 text-start border-b">
                        {index + 1 + (currentPage - 1) * 10}
                      </td>
                      <td className="px-2 py-1 text-start border-b">
                        {formatDateByCountry(LeadReport.LeadDate)}
                      </td>
                      <td className="px-2 py-1 text-start capitalize border-b break-words whitespace-normal">
                        {LeadReport.ClientName}
                      </td>
                      <td className="px-2 py-1 text-start capitalize border-b whitespace-normal">
                        {LeadReport.ProjectName}
                      </td>
                      <td className="px-2 py-1 text-start capitalize border-b">
                        {LeadReport.LeadType}
                      </td>
                      <td className="px-2 py-1 text-start border-b">
                        {USAComma(LeadReport.QuotedValue)}
                      </td>
                      <td className="px-2 py-1 text-start capitalize border-b">
                        {LeadReport.Status}
                      </td>
                      <td className="px-2 py-1 text-start capitalize border-b">
                        {LeadReport.Source}
                      </td>
                      <td className="px-2 py-1 text-start capitalize border-b">
                        {getLeadGroupName(LeadReport)}
                      </td>
                      <td className="px-2 py-1 text-start border-b">
                        {LeadReport.Status === "Won" ||
                          LeadReport.Status === "Lost"
                          ? " "
                          : formatDateByCountry(LeadReport.FollowupDate)}
                      </td>
                      <td
                        className="px-2 py-1 relative cursor-pointer text-center border-b"
                      >
                        <div
                          onClick={(e) => {
                            e.stopPropagation();

                            // Clear any other open dropdowns first
                            if (openDropdownId !== LeadReport._id) {
                              setOpenDropdownId(LeadReport._id);
                            } else {
                              setOpenDropdownId(null);
                            }
                          }}
                          className="p-1 cursor-pointer dropdown-toggle-icon" // Add class for identification
                        >
                          <EllipsisVertical />
                        </div>

                        {openDropdownId === LeadReport._id && (
                          <div
                            ref={dropdownsRef}
                            className={`z-50 p-1 absolute flex flex-col ${(index === currentData?.length - 1 || index === currentData?.length - 2) ? 'bottom-full' : 'top-full'} -left-3 bg-white rounded-md shadow border`}
                            onClick={(e) => e.stopPropagation()} // Prevent clicks inside dropdown from bubbling
                          >
                            <div
                              onClick={() => {
                                setOpenDropdownId(null);
                                navigate(`/dashboard/edit-lead/${LeadReport.id}`, {
                                  state: { from: location.pathname },
                                })
                              }}
                              className="p-1 flex gap-1 w-full justify-start align-middle items-center border-b cursor-pointer hover:bg-gray-50"
                            >
                              <span title="Edit">
                                <SquarePen size={15} className="text-blue-500" />
                              </span>
                              Edit
                            </div>
                            <div
                              onClick={() => {
                                setOpenDropdownId(null);
                                openDeleteModal(LeadReport.id);
                              }}
                              className="p-1 flex gap-1 w-full justify-start align-middle items-center cursor-pointer hover:bg-gray-50"
                            >
                              <span title="Delete">
                                <Trash2 size={15} className="text-blue-500" />
                              </span>
                              Delete
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      className="border p-4 text-start text-red-500"
                    >
                      {searchQuery
                        ? `No Result Found For "${searchQuery}"`
                        : "No Result Found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="pagination mt-2 flex justify-between items-center bg-white rounded-md p-1">
            <div>
              {totalItems > 0 ? (
                <>
                  Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                  {totalItems} Entries
                </>
              ) : (
                <>Showing 0 Entries</>
              )}
            </div>

            {totalPages > 1 && (
              <div>
                <button
                  onClick={() => setCurrentPage(1)}
                  className="px-2 py-2 mx-1 border rounded"
                  disabled={currentPage === 1}
                  title="First Page"
                >
                  <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                </button>
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  className="px-2 py-2 mx-2 border rounded"
                  disabled={currentPage === 1}
                >
                  <ChevronRightIcon className="w-5 h-5 rotate-180" />
                </button>

                {Array.from({ length: 3 }, (_, index) => {
                  const pageNumber = currentPage - 1 + index;
                  if (pageNumber >= 1 && pageNumber <= totalPages) {
                    return (
                      <button
                        key={pageNumber}
                        onClick={() => setCurrentPage(pageNumber)}
                        className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber ? "bg-gray-300" : ""
                          }`}
                      >
                        {pageNumber}
                      </button>
                    );
                  }
                  return null;
                })}

                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  className="px-2 py-2 mx-2 border rounded"
                  disabled={currentPage === totalPages}
                >
                  <ChevronRightIcon className="w-5 h-5" />
                </button>
                <button
                  onClick={() => setCurrentPage(totalPages)}
                  className="px-2 py-2 mx-1 border rounded"
                  disabled={currentPage === totalPages}
                  title="Last Page"
                >
                  <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadReport11;
